import { render, staticRenderFns } from "./CustomerCreateDialog.vue?vue&type=template&id=4586bbda&scoped=true"
import script from "./CustomerCreateDialog.vue?vue&type=script&lang=ts"
export * from "./CustomerCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4586bbda",
  null
  
)

export default component.exports